angular.module('bribac.views.singleMainGroup', [
  'ngRoute',
  'bribac.services.routeAuth',
  'bribac.services.api',
  'bribac.components.whenLoaded',
  'bribac.components.searchForm',
  'bribac.components.collapsingBox',
  'bribac.components.subjectOverview'
])

  .config(function(
    $routeProvider
  ) {
    $routeProvider.when('/main-group/:id', {
      templateUrl: 'single-main-group-view.html',
      controller: 'SingleMainGroupViewCtrl',
      controllerAs: '$ctrl',
      resolve: {access: function(routeAuth) {return routeAuth.requireAuth()}}
    })
  })

  .controller('SingleMainGroupViewCtrl', function(
    $routeParams,
    $location,
    $uibModal,
    api,
    KINDS,
    permissions
  ) {

    var $ctrl = this;
    $ctrl.permissions = permissions

    var mainGroupId = parseInt($routeParams.id);

    if (!isFinite(mainGroupId)) {
      return;
    }

    $ctrl.viewPromise = api.getView('mainGroup', mainGroupId).then(function(request) {
      $ctrl.mainGroup = request.data;
    });

    $ctrl.deleteMainGroup = function() {
      if (!confirm('Are you sure you want to delete this Main Group?')) {
        return;
      }
      api.delete(KINDS.MAIN_GROUP, mainGroupId)
        .then(function() {
          $uibModal.open({
            windowClass: 'modal-success',
            template: '<div class="modal-body">Main Group ' +
              ($ctrl.mainGroup.name || '') +
              ' (ID: ' + $ctrl.mainGroup.id + ') deleted successfully.</div>',
            size: 'sm'
          });
          setTimeout(function() {
            window.location = '/#!/';
          }, 2000);
        }, function(error) {
          $uibModal.open({
            windowClass: 'modal-danger',
            template: '<div class="modal-body">Error deleting Main Group ' +
              ($ctrl.mainGroup.name || '') +
              ' (ID: ' + $ctrl.mainGroup.id + '): ' +
              (error.data && error.data.errorMessage
                ? error.data.errorMessage
                : (error.statusText || 'Unknown error')) +
              '</div>',
            size: 'sm'
          });
        });
    };

  })
